var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgParticipantsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 15.8333C1.66797 14 3.16797 12.5 5.0013 12.5H8.33464C10.168 12.5 11.668 14 11.668 15.8333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7512 5.00029C9.91787 6.16696 9.91787 8.00029 8.7512 9.08362C7.58453 10.167 5.7512 10.2503 4.66787 9.08362C3.58453 7.91696 3.5012 6.16696 4.58453 5.00029C5.66787 3.83362 7.58453 3.91696 8.7512 5.00029",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 11.667H15.832C17.2487 11.667 18.332 12.7503 18.332 14.167",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.085 5.58301C16.9184 6.41634 16.9184 7.74967 16.085 8.49967C15.2517 9.24967 13.9184 9.33301 13.1684 8.49967C12.4184 7.66634 12.335 6.33301 13.1684 5.58301C13.9184 4.83301 15.2517 4.83301 16.085 5.58301",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgParticipantsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ParticipantsIcon.02bd04cd.svg";
export { ForwardRef as ReactComponent };